export default {"src":"/_next/static/media/instagram-round.ad7dae0f.svg","height":50,"width":50};